import { useState } from "react";
import { Button, Card, Flex, Form, Input, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../Context/LoaderContext";
import AuthService from "../../Service/auth.service";
import SuccessResult from "../../Components/SuccessResult/SuccessResult";
import FailureResult from "../../Components/FailureResult/FailureResult";
import "./index.scss";

const failureReason = ["Entered email not found"];

const ForgotPassword = () => {
  const { setLoading, isLoading, setLoadingMessage } = useLoader();
  const navigate = useNavigate();
  const authService = AuthService.getInstance();
  const [showFailure, setShowFailure] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  const handleEmailSubmit = async (values: any) => {
    setLoading(true);
    setLoadingMessage("Sending password reset link...");
    // Normalize email to lowercase for case-insensitive handling
    const normalizedEmail = values.email?.trim().toLowerCase();
    const response = await authService.sendPasswordResetMail(normalizedEmail);
    if (response?.status === 201) {
      setLoading(false);
      setShowSuccess(true);
      setLoadingMessage(null);
    } else {
      setLoading(false);
      setShowFailure(true);
      setLoadingMessage(null);
    }
  };

  const handleTryAgain = () => {
    setShowFailure(false);
    setShowSuccess(false);
  };

  const handleOk = () => {
    navigate("/");
  };

  return (
    <Flex className="forgot-password" align="center" justify="center">
      {!showSuccess && !showFailure && (
        <Card
          bordered
          className="forgot-password__card"
          title={
            <Typography.Title level={4} className="forgot-password__title">
              Forgot Password
            </Typography.Title>
          }
        >
          <Form
            name="email_form"
            className="forgot-password__form"
            onFinish={handleEmailSubmit}
            scrollToFirstError
          >
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: "Please enter a valid email address!",
                },
              ]}
            >
              <Input placeholder="Registered Email" />
            </Form.Item>

            <Flex className="forgot-password__button-group">
              <Button block type="default" onClick={() => navigate("/sign-in")}>
                Back to Sign In
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                block
                loading={isLoading}
              >
                Next
              </Button>
            </Flex>
          </Form>
        </Card>
      )}

      {showSuccess && !showFailure && (
        <SuccessResult
          title="Mail Sent"
          subTitle="A password reset link has been sent to your email. Please check your inbox to reset your password."
          onClick={handleOk}
          buttonTitle="Home"
        />
      )}

      {showFailure && !showSuccess && (
        <FailureResult
          title="Request Failed"
          subTitle="Your password reset request failed due to the following reasons:"
          reason={failureReason}
          onClick={handleTryAgain}
        />
      )}
    </Flex>
  );
};

export default ForgotPassword;
